import { InjectionToken } from '@angular/core';
import { Storage } from '@angular/fire/storage';

export const PICTURES_STORAGE = new InjectionToken<Storage | null>('PicturesStorage');
